import { LocationStrategy } from '@angular/common';
import { DOCUMENT, FactoryProvider, inject, InjectionToken } from '@angular/core';
import { WEB_COMPONENT_DEFAULT_URL } from './default-url-token';

export const WEB_COMPONENT_INITIAL_PATH: InjectionToken<string>
  = new InjectionToken<string>('Initial path inside web-component');

export const InitialPathProvider: FactoryProvider = {
  provide: WEB_COMPONENT_INITIAL_PATH,
  useFactory: (): string => {
    const hash: string = inject(DOCUMENT).location.hash;

    if (hash) {
      return hash.substring(1);
    }

    const locationStrategy: LocationStrategy = inject(LocationStrategy);
    const url: URL = new URL(locationStrategy.getBaseHref());
    const contentPath: string | null = url.searchParams.get('initialPath');

    if (contentPath) {
      return contentPath;
    }

    return inject(WEB_COMPONENT_DEFAULT_URL);
  },
};
